import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Button, ButtonGroup } from "react-bootstrap";
import AdminDataTable from "./AdminDataTable";
import Swal from "sweetalert2";
import { FaEdit, FaList, FaTrash, FaWallet } from "react-icons/fa";
import AdminPageHeader from "./AdminPageHeader";
import Navigation from "./Navigation";

function Deposits() {
  const [deposits, setDeposits] = useState([]);
  const [statusFilter, setStatusFilter] = useState(0); // default pending
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const token = localStorage.getItem('sessionToken');
  const fetchDeposit = async (status) => {
    try {
      setLoading(true);
      const res = await fetch(
        `${process.env.REACT_APP_API_PRODUCT_URL}api/deposit/?status=${status}`,
        {
          headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        }
      );
      if (!res.ok) {
        throw new Error("Gagal fetch data deposit");
      }
      const data = await res.json();
      setDeposits(data.deposits || []);
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Gagal mengambil data deposit", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDeposit(statusFilter);
  }, [statusFilter]);

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Yakin hapus deposit ini?",
      text: "Data yang dihapus tidak bisa dikembalikan!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, hapus!",
      cancelButtonText: "Batal",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await fetch(
            `${process.env.REACT_APP_API_PRODUCT_URL}api/deposit/${id}`,
            { method: "DELETE" }
          );
          if (!res.ok) {
            throw new Error("Gagal hapus deposit");
          }
          Swal.fire("Terhapus!", "Data deposit berhasil dihapus", "success");
          fetchDeposit(statusFilter); // refresh data
        } catch (err) {
          console.error(err);
          Swal.fire("Error", "Gagal menghapus deposit", "error");
        }
      }
    });
  };

  const columns = [
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: true,
      width: "80px",
    },
        {
      name: "Outlet",
      sortable: true,
      cell: (row) => (
        <div className="table-identity">
          <span className="table-identity__avatar">
            {String(row.outlet_id).slice(0, 2).toUpperCase()}
          </span>
          <span className="table-identity__meta">
            <strong>Outlet #{row.outlet_id}</strong>
            <small>Deposit request</small>
          </span>
        </div>
      ),
    },
    {
      name: "Jumlah",
      sortable: true,
      right: true,
      cell: (row) => (
        <span className="table-identity__meta">
          <strong>Rp {row.amount.toLocaleString("id-ID")}</strong>
          <small>{new Date(row.created_at).toLocaleString("id-ID", { dateStyle: "short", timeStyle: "short" })}</small>
        </span>
      ),
    },
    {
      name: "Status",
      selector: (row) =>
        row.status === 1 ? (
          <span className="badge bg-success">Sukses</span>
        ) : (
          <span className="badge bg-warning text-dark">Pending</span>
        ),
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="table-action-group">
          <FaEdit
            size={18}
            className="text-primary cursor-pointer"
            title="Edit"
            onClick={() => navigate(`/deposit/edit/${row.id}`)}
          />
          <FaTrash
            size={18}
            className="text-danger cursor-pointer"
            title="Delete"
            onClick={() => handleDelete(row.id)}
          />
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <div>
      <Navigation />
      <Container fluid className="admin-page-shell mt-4 px-4">
        <AdminPageHeader
          icon={FaWallet}
          eyebrow="Deposit review"
          title="Member Deposit"
          description="Pantau deposit pending dan sukses dari setiap outlet dalam tabel yang lebih rapi."
          breadcrumbs={[
            { label: 'Dashboard', to: '/dashboardadmin' },
            { label: 'Member Deposit' },
          ]}
          meta={(
            <span className="soft-stat">
              <FaList /> {deposits.length} deposits
            </span>
          )}
        />

        <div className="mb-3">
          <ButtonGroup>
            <Button
              variant={statusFilter === 0 ? "warning" : "outline-warning"}
              onClick={() => setStatusFilter(0)}
            >
              Pending
            </Button>
            <Button
              variant={statusFilter === 1 ? "success" : "outline-success"}
              onClick={() => setStatusFilter(1)}
            >
              Sukses
            </Button>
          </ButtonGroup>
        </div>

        <AdminDataTable
          columns={columns}
          data={deposits}
          progressPending={loading}
          pagination
          highlightOnHover
          striped
          dense
          emptyTitle="No deposit data found"
          emptyDescription="Belum ada transaksi deposit pada status yang sedang dipilih."
        />
      </Container>
    </div>
  );
}

export default Deposits;
